"use client";
import SoMeLink from "@/components/framework/footer/SoMeLink";
import { LocationContext } from "@/components/framework/locationswitcher/locationReducer";
import { type LocationType } from "@/sanity/types/locationList";
import { use, useMemo } from "react";


//#region [Props]
type LocationSoMeLinksProps = {
    locations?: LocationType[];
};
//#endregion

//#region [Component]
export default function LocationSoMeLinks({ locations }: LocationSoMeLinksProps) {
    const locationState = use(LocationContext);
    const selected = useMemo(() => {
        if ((locations?.length ?? 0) === 0 || locationState.selected.length === 0) {
            return [];
        }
        const teaterNr = locationState.selected.map(s => s.teaternr!.toString());

        return locations!.filter(loc => teaterNr.includes(loc.teaternr.toString()));
    }, [locations, locationState.selected]);

    return (<>
        {selected.map(sel => <SoMeLink key={sel._id} text={sel.name!} links={sel.someLinks} />)}
    </>);
}
//#endregion

//#region [Styles]

//#endregion